import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, ArrowUpRight } from "lucide-react";
import { useContent } from "../../context/ContentContext";

export default function Projects() {
  const { content } = useContent();
  const [filter, setFilter] = useState("All");
  const projects = content.projects;
  const categories = content.categories;
  const list = filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <section className="py-20 lg:py-28 bg-homi-light">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <span className="homi-section-tag text-homi-goldDark text-sm">Our Recent Work</span>
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-homi-black mt-3">Projects That Speak for Themselves</h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map((c) => (
              <button key={c} onClick={() => setFilter(c)}
                className={`px-5 py-2.5 rounded-lg font-heading font-semibold text-sm transition-colors ${filter === c ? "bg-homi-gold text-homi-black" : "bg-white text-homi-black hover:bg-homi-gold/15"}`}>
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p) => (
            <Link to={`/homi/projects/${p.id}`} key={p.id} className="group relative rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-homi-black/85 via-homi-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute inset-x-0 bottom-0 p-6 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span className="text-homi-gold text-xs font-heading font-bold uppercase tracking-wider">{p.category}</span>
                <div className="flex items-center justify-between gap-3 mt-1">
                  <h3 className="font-heading font-bold text-lg text-white">{p.title}</h3>
                  <span className="w-10 h-10 rounded-full bg-homi-gold flex items-center justify-center shrink-0">
                    <ArrowUpRight className="w-5 h-5 text-homi-black" />
                  </span>
                </div>
              </div>
              <span className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center group-hover:opacity-0 transition-opacity">
                <Plus className="w-5 h-5 text-homi-goldDark" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
